/* eslint-disable max-statements */
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
// import { ToggleButton } from 'primereact/togglebutton';
import { InputSwitch } from "primereact/inputswitch";
import DisputedIcon from '../../assets/DisputedIcon.svg';
import { metricValueFormat } from '../../utils/metricValueFormat';
import { AgentDisputeDetails } from '../agentDisputeDetails/AgentDisputeDetails';
import { LoadingSpinner } from '../loadingSpinner/loadingspinner';
import { ResolveAgentDispute } from '../resolveAgentDispute/ResolveAgentDispute';
import './scoreCardDashboardViewTable.scss';
import { colorCode, exportExcel } from './scorecard-dashboard-view-table-service';
import { MYMETRICS } from '../../constants';

interface propTypes {
    enableNavigateAgent?: boolean;
    ScoreCardAgentdata?: any;
    inputMonth?: number;
    inputYear?: number;
    supervisorNumber?: number;
    scorecardVersion?: number;
    TLApprovalColumns?: any;
    isFetching?: boolean;
}
export const ScoreCardDashboardViewTable = ({
    enableNavigateAgent,
    ScoreCardAgentdata,
    inputMonth,
    inputYear,
    supervisorNumber,
    scorecardVersion,
    TLApprovalColumns,
    isFetching,
}: propTypes) => {
    const toast = useRef(null);
    const uniqueKey = 'agent_number';
    const [agents, setAgents] = useState<any>(null);
    const [metricColHeader, setMetricColHeader] = useState<any>([]);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [hideTable, setHideTable] = useState<boolean>(true);
    // eslint-disable-next-line no-unsafe-optional-chaining
    const [expandedRows, setExpandedRows] = useState<any>();
    const [selectedDispute, setSelectedDispute] = useState<any>([]);
    const [agentNumbers, setAgentNumbers] = useState<any>([]);
    const [resolveAllClicked, setResolveAllClicked] = useState<boolean>(false);
    const [resolveDisputeData, setResolveDisputeData] = useState<any>([]);
    const [isDirectReport, setIsDirectReport] = useState<boolean>(true);
    const [showNonPayoutMetrics, setShowNonPayoutMetrics] = useState<boolean>(false);
    const [agentData, setAgentData] = useState<any>([]);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        agent_name: {
            operator: FilterOperator.AND,
            constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
        },
        total_metrics_attained: {
            operator: FilterOperator.AND,
            constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
        },
    });
    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const afilters = { ...filters };
        afilters.global.value = value;
        setFilters(afilters);
        setGlobalFilterValue(value);
    };
    const onRowCollapse = (event: any) => {
        console.log(event + 'RowCollapse');
    };
    const allowExpansion = (rowData: any) => {
        if (rowData) return true;
        else return false;
    };
    const rowExpansionTemplate = (rowData: any) => {
        return (
            <div className="orders-subtable">
                <AgentDisputeDetails
                    agentNumber={rowData?.agent_number}
                    supervisorNumber={supervisorNumber}
                    scorecardVersion={scorecardVersion}
                    inputyear={inputYear}
                    inputmonth={inputMonth}
                />
            </div>
        );
    };
    const totalAdditionalMetrics = useMemo(() => {
        if (!ScoreCardAgentdata?.data?.length) return 0;
        const firstAgent = ScoreCardAgentdata.data[0];
        const details = firstAgent?.agentMetrics?.[0]?.metricsDetails ?? {};
        return Object.values(details).filter((m: any) => m.is_payout_metric === false).length;
    }, [ScoreCardAgentdata]);

    const shouldShowToggle = totalAdditionalMetrics > 0;
    const agentNameBodyTemplate = (rowData: any) => {
        const agentName = rowData?.agent_name;
        return (
            <React.Fragment>
                {/* <img alt="" className="me-2" width={32} style={{ verticalAlign: 'middle' }} /> */}
                {enableNavigateAgent ? (
                    <Link
                        to={`${MYMETRICS}/${rowData.agent_number}/${rowData.scorecard_version_id}/${inputYear}-${inputMonth}`}
                    >
                        <span className="image-text">{agentName}</span>
                    </Link>
                ) : (
                    <span className="image-text">{agentName}</span>
                )}
            </React.Fragment>
        );
    };
    const agentIdBodyTemplate = (rowData: any) => {
        const agentNumber = rowData?.agent_number;
        return (
            <React.Fragment>
                {/* <img alt="" className="me-2" width={32} style={{ verticalAlign: 'middle' }} /> */}
                <span className="image-text">{agentNumber}</span>
            </React.Fragment>
        );
    };
    const metricsMetBodyTemplate = (rowData: any) => {
        return (
            <div
                className="image-text"
                style={{
                    backgroundColor: colorCode(rowData?.total_metrics_attained),
                    borderRadius: '30px',
                    textAlign: 'center',
                    width: '54px',
                }}
            >
                {rowData?.total_metrics_attained}
            </div>
        );
    };

    const metricsOneBodyTemplate = (rowData: any, props: any) => {
        let metricValue = rowData?.agentMetrics[0]?.metricsDetails[props?.column?.props.header]?.metric_value;
        const disputeStatus =
            rowData?.agentMetrics[0]?.metricsDetails[props?.column?.props.header]?.dispute_status_id;
        const metricTypeName =
            rowData?.agentMetrics[0]?.metricsDetails[props?.column?.props.header]?.metric_type_name;
        if (metricValue === undefined || metricValue === null) {
            metricValue = '--';
        } else if (metricTypeName !== undefined) {
            metricValue = metricValueFormat(metricValue, metricTypeName);
        }
        let metricElement = <span className="image-text">{metricValue}</span>;
        if (disputeStatus === 1) metricElement = <span className="image-text disputed">{metricValue}</span>;
        return metricElement;
    };
    const metricsDisputedBodyTemplate = (rowData: any) => {
        const disputeStatus = Object.values(rowData?.agentMetrics[0]?.metricsDetails).find(
            (item: any) => item.dispute_status_id === 1
        );
        let metricElement = <div />;
        if (disputeStatus !== undefined)
            metricElement = <img className="justify-content-left " src={DisputedIcon} alt="disputed" />;
        return metricElement;
    };
    const statusTemplate = (rowdata: any) => {
        if (rowdata.review_status_id === 3) return <span className="statusColumn">Disputed</span>;
        else if (rowdata.review_status_id === 2)
            return (
                <span className="statusColumn" style={{ backgroundColor: '#64d96e' }}>
                    Reviewed
                </span>
            );
        else if (rowdata.review_status_id === 1) return <span className="statusColumn">Needs Review</span>;
        else return '';
    };
    const onResolveAllDisputesClicked = () => {
        setResolveAllClicked(true);
        const data = {
            employeenumber: agentNumbers,
            scorecardVersionId: scorecardVersion,
            supervisornumber: supervisorNumber,
            month: inputMonth,
            year: inputYear,
        };
        setResolveDisputeData(data);
    };
    const renderHeader = () => {
        return (
            <div className="flex-display flex justify-content-between exportexcel" style={{ flexWrap: 'wrap', alignItems: 'center' }}>
                {/* Row 1: Search + Direct Reports toggle */}
                <span className="p-input-icon-left flex-display">
                    <i className="pi pi-search" />
                    <InputText
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                    />
                    <div className='display-flex-center'>
                        <p className='margin-bottom-0 margin-left margin-right'>Include Prior Reports</p>
                        <InputSwitch checked={isDirectReport} onChange={(e) => setIsDirectReport(e.value)} />
                        <p className='margin-bottom-0 margin-left direct-remportees-color'>Direct Reports</p>
                    </div>
                </span>

                {/* Row 1: Action buttons (right side) */}
                <div className="float-end">
                    <Button
                        disabled={agentNumbers.length === 0}
                        type="button"
                        onClick={onResolveAllDisputesClicked}
                        className="btn-primary"
                        label="Resolve All Disputes"
                        icon="pi pi-check"
                    />
                    <Button
                        type="button"
                        style={{ marginLeft: 15 }}
                        icon="pi pi-upload me-2"
                        className="btn-export mr-2 me-2 float-end"
                        onClick={() => exportExcel(agents, metricColHeader)}
                        data-pr-tooltip="XLS"
                    >
                        Export
                    </Button>
                </div>

                {/* Row 2: Show Non-Payout Metrics + Total Additional Metrics count */}
                {shouldShowToggle && (
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', gap: '8px', marginTop: '25px' }}>
                    <span style={{ marginRight: 'auto', display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <p style={{ color: '#7B2FBE', fontWeight: '600', margin: 0 }}>
                            Show Non-Payout Metrics
                        </p>
                        <InputSwitch
                            checked={showNonPayoutMetrics}
                            onChange={(e) => setShowNonPayoutMetrics(e.value)}
                            className="violet-switch"
                        />
                    </span>
                    {showNonPayoutMetrics && (
                        <span style={{ marginLeft: 'auto', fontWeight: '600' }}>
                            Total Additional Metrics: <strong>{totalAdditionalMetrics}</strong>
                        </span>
                    )}                    
                </div>
                )}
            </div>
        );
    };
    const header = renderHeader();
    useEffect(() => {
        if (ScoreCardAgentdata?.data?.length > 0) {
            const filteredData = ScoreCardAgentdata.data.map((agent: any) => {
                const filteredAgentMetrics = agent.agentMetrics?.map((agentMetric: any) => {
                    const filteredMetricsDetails = Object.fromEntries(
                        Object.entries(agentMetric.metricsDetails ?? {}).filter(([key]) => {
                            // If showNonPayoutMetrics is true → show everything, no filter
                            if (showNonPayoutMetrics) return true;
                            // If false → show only payout metrics
                            return agentMetric.metricsDetails[key].is_payout_metric === true;
                        })
                    );
                    return {
                        ...agentMetric,
                        metricsDetails: filteredMetricsDetails,
                    };
                });
                return {
                    ...agent,
                    agentMetrics: filteredAgentMetrics,
                };
            });
            setAgentData(filteredData);
        } else {
            setAgentData([]);
        }
    }, [ScoreCardAgentdata, showNonPayoutMetrics]);
    useEffect(() => {
        setAgents([]);
        if (agentData?.length > 0) {
            const agentsDirectReportData = isDirectReport === true ? agentData.filter((item: any) => item.is_direct_report === true) : agentData;

            setAgents(agentsDirectReportData);
        } else {
            setAgents([]);
        }
    }, [agentData, isDirectReport]);

    useEffect(() => {
        if (agentData?.length > 0) {
            agentData.map((x: any) => {
                const obj = Object.keys(x?.agentMetrics[0]?.metricsDetails);
                setMetricColHeader(obj);
                return obj;
            });
        }
        if (agents?.length > 0) setHideTable(false);
        else setHideTable(true);
    }, [agentData, agents]);
    const onSelectionChange = (event: any) => {
        setSelectedDispute(event.value);
        window.localStorage.unCheckBox = false;
        const empnumbers = event.value.map((x: any) => x.agent_number);
        setAgentNumbers(empnumbers);
    };
    const isRowSelectable = (event: any) => {
        return event.data.review_status_id === 3;
    };
    useEffect(() => {
        if (window.localStorage.unCheckBox === 'true') {
            setSelectedDispute([]);
            setResolveAllClicked(false);
            setAgentNumbers([]);
            setResolveDisputeData([]);
        }
    }, [window.localStorage.unCheckBox]);

    const rowClass = (data: any) => {
        return {
            'bg-warning': data.is_direct_report === false
        };
    };
    return (
        <div className="card datatable-doc-demo border-0 pt-2">
            <div>{isFetching ? <LoadingSpinner /> : ''}</div>
            <Toast ref={toast} />
            {
                <DataTable
                    rowClassName={rowClass}
                    hidden={hideTable}
                    value={agents}
                    paginator={agents?.length > 5}
                    className="scorecardDashboardVieTable"
                    header={header}
                    rows={5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    dataKey={uniqueKey}
                    filters={filters}
                    filterDisplay="menu"
                    globalFilterFields={['agent_name', 'total_metrics_attained']}
                    emptyMessage="No agents found."
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    selectionMode="checkbox"
                    expandedRows={expandedRows}
                    onRowToggle={(e) => {
                        setExpandedRows(e.data);
                    }}
                    onRowCollapse={onRowCollapse}
                    rowExpansionTemplate={rowExpansionTemplate}
                    selection={selectedDispute}
                    onSelectionChange={onSelectionChange}
                    isDataSelectable={isRowSelectable}
                    sortField="agent_name"
                    sortOrder={1}
                >
                    <Column header="" style={{ width: '3rem' }} body={metricsDisputedBodyTemplate} />
                    <Column
                        selectionMode="multiple"
                        headerStyle={{ width: '1rem' }}
                        bodyStyle={{ width: '1rem' }}
                    />
                    <Column
                        header="Agent"
                        sortable
                        sortField="agent_name"
                        filterField="agent_name"
                        showFilterMatchModes={false}
                        filterMenuStyle={{ width: '20rem' }}
                        style={{ width: '13rem' }}
                        body={agentNameBodyTemplate}
                    />
                    <Column
                        header="Oracle Id"
                        sortable
                        sortField="agent_number"
                        filterField="agent_number"
                        showFilterMatchModes={false}
                        filterMenuStyle={{ width: '20rem' }}
                        style={{ width: '13rem' }}
                        body={agentIdBodyTemplate}
                    />
                    <Column
                        header="Metrics Met"
                        sortable
                        sortField="total_metrics_attained"
                        filterField="total_metrics_attained"
                        showFilterMatchModes={false}
                        filterMenuStyle={{ width: '10rem' }}
                        style={{ minWidth: '10rem' }}
                        body={metricsMetBodyTemplate}
                    />
                    {metricColHeader.map((metricHeader: any) => {
                        return (
                            <Column
                                key={metricHeader}
                                header={metricHeader}
                                showFilterMatchModes={false}
                                filterMenuStyle={{ width: '10rem' }}
                                style={{ minWidth: '10rem' }}
                                body={metricsOneBodyTemplate}
                            />
                        );
                    })}
                    {TLApprovalColumns?.map((approvalColumn: any) => {
                        return (
                            <Column
                                header={approvalColumn.name}
                                key={approvalColumn.id}
                                sortable
                                sortField={approvalColumn.field}
                                filterField={approvalColumn.field}
                                showFilterMatchModes={false}
                                filterMenuStyle={{ width: '15rem' }}
                                style={{ width: '10rem' }}
                                body={statusTemplate}
                            />
                        );
                    })}
                    <Column
                        key="expand"
                        expander={allowExpansion}
                        style={{ width: '4em', marginRight: '10px' }}
                    />
                </DataTable>
            }
            {resolveAllClicked ? (
                <div>
                    <ResolveAgentDispute
                        data={resolveDisputeData}
                        disputeDialogEnable
                        resolveAllClicked
                        setResolveAllClicked={setResolveAllClicked}
                        scorecardVersion={scorecardVersion}
                        inputyear={inputYear}
                        inputmonth={inputMonth}
                    />{' '}
                </div>
            ) : (
                ''
            )}
        </div>
    );
};
